import { Routes } from '@angular/router';
import {Login} from './login/login';
import { AuthLayout } from './auth-layout/auth-layout';
import { RecoverPassword } from './recover-password/recover-password';
import { ResetPassword } from './reset-password/reset-password';
import { LayoutService } from '../../services/layout.service';
import { inject } from '@angular/core';
import { firstValueFrom, lastValueFrom } from 'rxjs';

export const authRoutes: Routes = [
  {
    path: '',
    loadComponent: () => AuthLayout,
    children: [
      {
        path: 'login',
        loadComponent: () => Login,
        title: async () => {
          const title = await firstValueFrom(inject(LayoutService).systemTitle$);
          return `${title} - Login`;
        }
      },
      {
        path: 'recover-password',
        loadComponent: () => RecoverPassword,
        title: async () => {
          const title = await firstValueFrom(inject(LayoutService).systemTitle$);
          return `${title} - Esqueceu sua senha?`;
        }
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      }
    ]
  },
  {
    path: 'reset-password/:code',
    loadComponent: () => ResetPassword,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Recuperar Senha`;
    }
  }
];
